// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function page1_viewportEnter(event) {
    $w('#topStrip').hide(); //hidden on load
    $w('#bottomStrip').show();
}

export function page1_viewportLeave(event) {
	$w('#topStrip').show();
    $w('#bottomStrip').hide();
}